<template>
  <div class="heading-block" :class="`align-${alignment}`">
    <component :is="data.level || 'h2'" class="heading-text">{{ data.text }}</component>
    <p v-if="data.subtitle" class="subtitle">{{ data.subtitle }}</p>
  </div>
</template>

<script>
export default {
  name: 'HeadingBlock',
  props: {
    data: {
      type: Object,
      required: true,
      validator: (value) => {
        return value.text !== undefined
      }
    }
  },
  computed: {
    alignment() {
      return this.data.alignment || 'center'
    }
  }
}
</script>

<style scoped>
.heading-block {
  padding: 0;

  &.align-left { text-align: left; }
  &.align-center { text-align: center; }
  &.align-right { text-align: right; }
}

.heading-text {
  margin: 0;
  color: var(--color-text);
  font-family: var(--font-decorative);
  line-height: 1.3;
}

h1.heading-text {
  font-size: var(--font-2xl);
}

h2.heading-text {
  font-size: var(--font-xl);
}

h3.heading-text {
  font-size: var(--font-lg);
}

.subtitle {
  margin: 0.4em 0 0;
  color: color-mix(in srgb, var(--color-text) 70%, var(--color-bg));
  font-size: var(--font-sm);
  line-height: 1.5;
}
</style>
